/* ============================================
   ACES MEN'S GROOMING — THEME JS
   ============================================ */
(function () {
  'use strict';

  /* ── CART STATE ── */
  var cartCount = 0;

  /* ── HELPERS ── */
  function openCart() {
    var d = document.getElementById('CartDrawer');
    var o = document.getElementById('CartOverlay');
    if (d) d.classList.add('open');
    if (o) o.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    var d = document.getElementById('CartDrawer');
    var o = document.getElementById('CartOverlay');
    if (d) d.classList.remove('open');
    if (o) o.classList.remove('active');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    var el = document.getElementById('CartCount');
    if (!el) return;
    cartCount = count;
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  }

  function refreshCartDrawer() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return fetch('/?sections=cart-drawer&_=' + Date.now(), { cache: 'no-store' });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var newDrawer = tmp.querySelector('#CartDrawer');
          var oldDrawer = document.getElementById('CartDrawer');
          if (newDrawer && oldDrawer) {
            oldDrawer.innerHTML = newDrawer.innerHTML;
            bindCartDrawerEvents();
          }
        }
      })
      .catch(function (e) { console.error('Cart refresh error:', e); });
  }

  /* ── GLOBAL ADD TO CART ── */
  window.acesAddToCart = function (variantId, btn) {
    if (!variantId) return;
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then(function () {
      refreshCartDrawer();
      openCart();
      if (btn) {
        btn.textContent = 'Added!';
        btn.style.background = '#e0b050';
        setTimeout(function () {
          btn.textContent = origText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      }
    })
    .catch(function (err) {
      console.error('Add to cart error:', err);
      if (btn) { btn.textContent = origText; btn.disabled = false; }
    });
  };

  /* ── CART DRAWER EVENTS ── */
  function bindCartDrawerEvents() {
    /* Close button */
    var closeBtn = document.getElementById('CartClose');
    if (closeBtn) closeBtn.onclick = closeCart;

    /* Overlay */
    var overlay = document.getElementById('CartOverlay');
    if (overlay) overlay.onclick = closeCart;

    /* Remove item links */
    document.querySelectorAll('[data-remove-line]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var line = this.dataset.removeLine;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity: 0 })
        })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCartDrawer(); })
        .catch(function (e) { console.error('Remove item error:', e); });
      });
    });

    /* Qty buttons in drawer */
    document.querySelectorAll('[data-qty-line]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var self = this;
        var line = parseInt(this.dataset.qtyLine);
        var action = this.dataset.qtyAction;
        var qtyEl = this.parentNode.querySelector('.drawer-qty-val');
        var current = parseInt(qtyEl ? qtyEl.textContent : 1);
        var newQty = action === 'plus' ? current + 1 : Math.max(0, current - 1);

        /* Disable both buttons on this item while updating */
        var siblings = document.querySelectorAll('[data-qty-line="' + line + '"]');
        siblings.forEach(function (b) { b.disabled = true; });

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: newQty })
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);

          if (newQty === 0) {
            /* Item removed — re-render the whole drawer */
            refreshCartDrawer();
            return;
          }

          /* Update qty display */
          if (qtyEl) qtyEl.textContent = newQty;

          /* Update line item price directly */
          var priceEl = document.querySelector('[data-line-price="' + line + '"]');
          if (priceEl && cart.items[line - 1]) {
            priceEl.textContent = '$' + (cart.items[line - 1].final_line_price / 100).toFixed(2);
          }

          /* Update subtotal */
          var subtotalEl = document.getElementById('CartSubtotal');
          if (subtotalEl) {
            subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
          }

          /* Update free shipping bar */
          if (window.AcesCartShipbar) window.AcesCartShipbar.refresh();

          /* Re-enable buttons */
          siblings.forEach(function (b) { b.disabled = false; });
        })
        .catch(function (e) {
          console.error('Qty update error:', e);
          siblings.forEach(function (b) { b.disabled = false; });
        });
      });
    });
  }

  /* ── CART OPEN BUTTONS ── */
  function bindCartOpenButtons() {
    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openCart();
      });
    });
  }

  /* ── PRODUCT PAGE FORM ── */
  function bindProductForm() {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantSelect = document.getElementById('ProductVariant');
      var qtyInput = document.getElementById('Qty');
      var btn = document.getElementById('AddToCartBtn');
      if (!variantSelect) return;

      var variantId = parseInt(variantSelect.value);
      var qty = parseInt(qtyInput ? qtyInput.value : 1) || 1;
      var origText = btn ? btn.textContent : 'Add to Cart';

      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed');
        return r.json();
      })
      .then(function () {
        refreshCartDrawer();
        openCart();
        if (btn) {
          btn.textContent = 'Added!';
          btn.style.background = '#e0b050';
          setTimeout(function () {
            btn.textContent = origText;
            btn.style.background = '';
            btn.disabled = false;
          }, 2500);
        }
      })
      .catch(function () {
        if (btn) { btn.textContent = origText; btn.disabled = false; }
      });
    });
  }

  /* ── MOBILE NAV ── */
  function bindMobileNav() {
    var hbtn = document.getElementById('HamburgerBtn');
    var closeBtn = document.getElementById('MobileNavClose');
    var overlay = document.getElementById('NavOverlay');
    var nav = document.getElementById('MobileNav');

    function openNav() {
      if (nav) nav.classList.add('open');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    function closeNav() {
      if (nav) nav.classList.remove('open');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (hbtn) hbtn.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (overlay) overlay.addEventListener('click', closeNav);
  }

  /* ── STICKY NAV ── */
  function bindStickyNav() {
    var nav = document.getElementById('SiteNav');
    if (!nav) return;
    window.addEventListener('scroll', function () {
      nav.classList.toggle('is-scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ── SCROLL FADE ANIMATIONS ── */
  function bindScrollAnimations() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.fade-in').forEach(function (el) {
        el.classList.add('vis');
      });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('vis');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    document.querySelectorAll('.fade-in:not(.vis)').forEach(function (el) {
      obs.observe(el);
    });
  }

  /* ── TESTIMONIAL SLIDER ── */
  function bindTestimonials() {
    var dots = document.querySelectorAll('.test-dot');
    var quote = document.getElementById('TestQuote');
    var author = document.getElementById('TestAuthor');
    if (!dots.length || !quote) return;

    var idx = 0;
    var timer;

    function goTo(i) {
      idx = i;
      dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        goTo(i);
        clearInterval(timer);
        timer = setInterval(function () { goTo((idx + 1) % dots.length); }, 5000);
      });
    });

    timer = setInterval(function () { goTo((idx + 1) % dots.length); }, 5000);
  }

  /* ── COLLECTION FILTER BUTTONS ── */
  function bindFilterButtons() {
    document.querySelectorAll('.filter-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.filter-btn').forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
        var filter = this.dataset.filter;
        document.querySelectorAll('#CollectionGrid .prod-card').forEach(function (card) {
          card.style.display = (filter === 'all' || card.dataset.type === filter) ? '' : 'none';
        });
      });
    });
  }

  /* ── PAGE LOADER ── */
  function initLoader() {
    var l = document.getElementById('PageLoader');
    if (l) {
      setTimeout(function () {
        l.style.opacity = '0';
        setTimeout(function () { l.style.display = 'none'; }, 500);
      }, 600);
    }
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function () {
    bindCartDrawerEvents();
    bindCartOpenButtons();
    bindProductForm();
    bindMobileNav();
    bindStickyNav();
    bindScrollAnimations();
    bindTestimonials();
    bindFilterButtons();

    /* Cart drawer checkout button */
    document.addEventListener('submit', function(e) {
      if (e.target.id === 'CartDrawerCheckout') {
        e.preventDefault();
        window.location.href = '/checkout';
      }
    });

    /* Quick add buttons on product cards */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.prod-quick-add');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.dataset.variantId;
      if (variantId) {
        window.acesAddToCart(variantId, btn);
      }
    });
  });

  window.addEventListener('load', function () {
    initLoader();
    /* Sync cart count on page load */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  });

})();
